module.exports = __webpack_public_path__ + "static/media/MaskGroup2.dd32f638.jpg";